import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "book-highlights" }
const _hoisted_2 = { class: "container book-highlights__container" }

import DocLayout from '@/app/components/doc/Layout.vue'
import Hero from '@/app/components/doc/highlights/Hero.vue'
import HighlightsList from '@/app/components/doc/highlights/HighlightsList.vue'

import type { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'Highlights',
  props: {
    doc: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DocLayout, {
    doc: __props.doc,
    "show-text-controls": false
  }, {
    "page-content": _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Hero, {
            doc: __props.doc,
            title: "Highlights, notes and bookmarks of"
          }, null, 8, ["doc"]),
          _createVNode(HighlightsList, { doc: __props.doc }, null, 8, ["doc"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["doc"]))
}
}

})